import { default_dashboard } from '@core/breadcrumbs';

const module = default_dashboard
  .extend('integrations')
  .add('integrations.breadcrumb.title', { name: 'integrations.dashboard' });

const auth_breadcrumbs = module
  .extend('integrations.tabs.auth')
  .add('integrations.breadcrumb.auth.index', { name: 'integrations.tabs.auth' });

const cases_breadcrumbs = module
  .extend('integrations.tabs.cases')
  .add('integrations.breadcrumb.cases.index', { name: 'integrations.tabs.cases' });

const users_breadcrumbs = module
  .extend('integrations.tabs.users')
  .add('integrations.breadcrumb.users.index', { name: 'integrations.tabs.users' });

const numbers_breadcrumbs = module
  .extend('integrations.tabs.numbers')
  .add('integrations.breadcrumb.numbers.index', { name: 'integrations.tabs.numbers' });

const integrations_breadcrumbs = [
  auth_breadcrumbs,
  cases_breadcrumbs,
  users_breadcrumbs,
  numbers_breadcrumbs
];

export { integrations_breadcrumbs };
